import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import { BacklogError } from "../errors/BacklogError";
import type { EmptyObject } from "../types/EmptyObject";

/**
 * Get List of Groups グループ一覧の取得
 *
 * Returns list of groups.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Get List of Teams.
 */
export function getListOfGroups(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("not supported.");
}

/**
 * Add Group グループの追加
 *
 * Adds new group. You can’t use this API at new plan space.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Add Team.
 */
export function addGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("not supported.");
}

/**
 * Get Group グループ情報の取得
 *
 * Returns information about group.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Get Team.
 */
export function getGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Update Group グループ情報の更新
 *
 * Updates information about group. You can’t use this API at new plan space.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Update Team.
 */
export function updateGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Delete Group グループの削除
 *
 * Deletes group. You can’t use this API at new plan space.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Delete Team.
 */
export function deleteGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Get Project Group List プロジェクトグループ一覧の取得
 *
 * Returns list of project groups.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Get Project Team List.
 */
export function getProjectGroupList(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Add Project Group プロジェクトグループの追加
 *
 * Add group to project.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Add Project Team.
 */
export function addProjectGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Delete Project Group プロジェクトグループの削除
 *
 * Removes a group from the project.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Delete Project Team.
 */
export function deleteProjectGroup(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}

/**
 * Get Group Icon グループアイコンの取得
 *
 * Downloads group icon.
 *
 * @deprecated This API has been deprecated and is no longer recommended for use. Please replace it with Get Team Icon.
 */
export function getGroupIcon(
	config: BacklogConfig,
	params: EmptyObject,
	context?: BacklogApiContext,
): Promise<BacklogResponse<EmptyObject>> {
	throw new BacklogError("Method not implemented.");
}
